/** Custom breakpoints: max-width 992px, 860px, 576px, 430px */
export const LAYOUT_BREAKPOINTS = {
	MAX_DESKTOP: "(min-width: 992px)",
	DESKTOP: "(max-width: 991px) and (min-width: 860px)",
	TABLET: "(max-width: 859px) and (min-width: 576px)",
	MOBILE: "(max-width: 575px)",
	MOBILE_SMALL: "(max-width: 480px)",
	SHORT_VIEWPORT: "(max-height: 800px)",
	COMPACT_GOALS: "(max-height: 530px)",
} as const;
